import { Attributes, EnumHelper, List, LookupBase, Misc } from '@singularsystems/neo-core';
import { ReportType } from '../ReportType';
import LetterAuthorisationRequiredSignatory from '../LetterAuthorisationRequiredSignatory';
import LetterAuthorisationSignatory from '../LetterAuthorisationSignatory';

export default class LetterAuthorisationBatchLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public letterAuthorisationBatchId: number = 0;

    public reportType: ReportType = null!;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public entityId: number = 0;

    public entity: string = "";

    public readonly description: string | null = null;

    @Attributes.Date()
    public readonly reportStartDate: Date | null = null;

    @Attributes.Date()
    public reportDate: Date = new Date();

    @Attributes.Integer()
    public letterCount: number = 0;

    @Attributes.Observable()
    @Attributes.Integer()
    public completeCount: number = 0;

    @Attributes.Integer()
    public sentCount: number = 0;

    @Attributes.Integer()
    public readonly savedCount: number = 0;

    @Attributes.Observable()
    public isAuthorised: boolean = false;

    public hasUnauthorisedRecords: boolean = false;

    @Attributes.Observable()
    @Attributes.Integer()
    public unlinkedRecordCount: number = 0;

    public allowEmail: boolean = false;

    public requiredSignatories = new List(LetterAuthorisationRequiredSignatory);

    // Client only properties / methods

    public get hasDifferentDates() {
        return this.reportStartDate?.getTime() !== this.reportDate.getTime();
    }

    @Attributes.Integer()
    public get remaining() {
        return this.letterCount - this.completeCount;
    }

    public get remainingToSend() {
        return this.letterCount - this.sentCount;
    }

    public signatories: LetterAuthorisationSignatory[] | null = null;

    public setSignatories(signatories: LetterAuthorisationSignatory[]) {
        this.signatories = signatories;

        if (this.requiredSignatories) {
            for (let signatory of this.requiredSignatories) {
                signatory.model = signatories.find(s => s.letterAuthorisationSignatoryId === signatory.signatoryId) ?? null;
                signatory.name = signatory.model?.display ?? "?";
            }
        }
    }

    public get signatoryNames() {
        if (this.requiredSignatories) {
            return this.requiredSignatories.map(c => c.name).join(", ");
        }
        return "";
    }

    @Attributes.Display("Report Type")
    public get reportTypeName() {
        if (this.reportType) {
            return EnumHelper.getItemMetadata(ReportType, this.reportType).display;
        } else {
            return "";
        }
    }
}